import React from 'react'
import {Link} from 'react-router-dom'
import {ResumenSeriesNormativa} from '../../../interfaces/normativa.interface'

interface PropsSeriesPendientes {
  series: ResumenSeriesNormativa | null
}

const SeriesPendientes = ({series}: PropsSeriesPendientes) => {
  if (!series) return null

  const pendientes = series.pendientes ?? []

  return (
    <div className='normativa-bloque'>
      <h3 className='card-title l'>Series de sus documentos</h3>
      <div className='normativa-resumen'>
        <div className='normativa-resumen-item'>
          <p className='normativa-dato'>Series registradas</p>
          <p className='normativa-valor m'>{series.total ?? 0}</p>
        </div>
        <div className='normativa-resumen-item'>
          <p className='normativa-dato'>Series listas para la versión 2</p>
          <p className='normativa-valor m'>{series.cumplen ?? 0}</p>
        </div>
        <div className='normativa-resumen-item'>
          <p className='normativa-dato'>Series por migrar</p>
          <p className='normativa-valor m'>{series.faltan ?? 0}</p>
        </div>
      </div>

      {pendientes.length === 0 ? (
        <p className='normativa-texto m'>
          Todas las series registradas cumplen el formato que exige la versión 2.
        </p>
      ) : (
        <React.Fragment>
          <p className='normativa-texto m'>
            Las series siguientes todavía no cumplen el formato de la versión 2. Corríjalas desde el
            estado de documentos de cada establecimiento.
          </p>
          <div className='normativa-tabla-contenedor'>
            <table className='table-main-responsive responsive-table-main td-left'>
              <thead>
                <tr>
                  <td>Establecimiento</td>
                  <td>Serie</td>
                  <td>Motivo</td>
                </tr>
              </thead>
              <tbody>
                {pendientes.map((serie, indice) => (
                  <tr key={`${serie.idsucursaldocumento ?? indice}-${indice}`}>
                    <td data-label='Establecimiento'>{serie.nombresucursal}</td>
                    <td data-label='Serie'>{serie.serie}</td>
                    <td data-label='Motivo'>{serie.motivo}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <Link
            to={'/gestion-usuarios/estado-documentos'}
            className='m button transparent w-inline-block normativa-boton-corto'
          >
            <div>Ir al estado de documentos</div>
          </Link>
        </React.Fragment>
      )}
    </div>
  )
}

export default SeriesPendientes
